var map = {
	"./account-details.tsx": 4462,
	"./arrow-right.tsx": 5012,
	"./arrow.tsx": 27313,
	"./chevron-up.tsx": 88755,
	"./close-filled.tsx": 62807,
	"./close.tsx": 34886,
	"./error-hexagon.tsx": 19931,
	"./exclusive-close-button.tsx": 16246,
	"./fanduel-shield.tsx": 64699,
	"./favorite-game.tsx": 10673,
	"./favorites.tsx": 84885,
	"./filter.tsx": 19048,
	"./fullscreen.tsx": 13289,
	"./genre.tsx": 13739,
	"./geolocation-icons/alert-icon.tsx": 89688,
	"./geolocation-icons/check-icon.tsx": 78102,
	"./geolocation-icons/pin-icon.tsx": 50841,
	"./info.tsx": 72038,
	"./play.tsx": 88480,
	"./plus.tsx": 31594,
	"./search-magnifying-glass.tsx": 15767,
	"./slots.tsx": 181,
	"./social-tag.tsx": 5184,
	"./sound-off.tsx": 143,
	"./sound-on.tsx": 14227,
	"./studio.tsx": 73444,
	"./swj-icons/site-wide-jackpot-bolt-radio.tsx": 2730,
	"./swj-icons/site-wide-jackpot-bolt.tsx": 1732,
	"./swj-icons/site-wide-jackpot-checkmark.tsx": 18552,
	"./swj-icons/site-wide-jackpot-glow-border.tsx": 76077,
	"./swj-icons/site-wide-jackpot-slots.tsx": 65628,
	"./swj-icons/site-wide-jackpot-toggle-off.tsx": 42941,
	"./swj-icons/site-wide-jackpot-toggle-on.tsx": 15881,
	"./swj-icons/site-wide-jackpot-trophy.tsx": 71203,
	"./swj-icons/swj-icon-radio-base.tsx": 36432,
	"./system-error.tsx": 53720,
	"./theme.tsx": 65589,
	"./volatility-high.tsx": 22396,
	"./volatility-info.tsx": 99740,
	"./volatility-low.tsx": 47998,
	"./volatility-medium.tsx": 98701,
	"./zone-new-tag.tsx": 47370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15792;